export default __webpack_public_path__ + "stc/media/img-ttl-contact.84d0b293.svg";